import React, { useRef, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import Recaptcha from "../../Recaptcha";
import ReCAPTCHA from "react-google-recaptcha";
import { getCloudflareCaptchaTokenAsync } from "../../../Form/helpers";

interface CloudflareCaptchaI {
  executeAsync: () => Promise<void>;
  getResponse: () => string | null;
  reset: () => void;
}

const SeparatedRecaptcha = ({
  callback,
}: {
  callback: (token: string) => Promise<void>;
}) => {
  const recaptchaRef = useRef<ReCAPTCHA | CloudflareCaptchaI>(null);
  const { getBasicSettingsData } = useContent();

  const generateToken = async () => {
    const captchaType = getBasicSettingsData().recaptchaType;
    const token =
      captchaType === "google"
        ? await (recaptchaRef.current as ReCAPTCHA)?.executeAsync()
        : await getCloudflareCaptchaTokenAsync(
            recaptchaRef as React.MutableRefObject<CloudflareCaptchaI>
          );

    if (callback && token) {
      await callback(token);
    }
  };

  useEffect(() => {
    generateToken();
  }, [callback]);

  return (
    <Recaptcha
      recaptchaRef={recaptchaRef as React.RefObject<ReCAPTCHA>}
      onSuccess={() => void 0}
    />
  );
};

const RecaptchaMemo = React.memo(SeparatedRecaptcha);

export default RecaptchaMemo;
